module.exports = __webpack_public_path__ + "media/images/flags/1x1/bhs-b4a8d3e15ba55aa4460c22434ffd6b49.svg";